import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { handleGql403 } from '../../../../utils';
import {
  StandardDeliveryReportFiltersInput,
  UpdateReportInput,
  UpdateStandardDeliveryReportMutation,
  UpdateStandardDeliveryReportMutationVariables,
} from '../../types';
import { onUpdateReport } from '../utils';
import { UPDATE_STANDARD_DELIVERY_REPORT } from './updateStandardDeliveryReport';

type UseUpdateStandardDeliveryReport = {
  handleUpdateStandardDeliveryReport: (
    id: string,
    report: UpdateReportInput,
    filters: StandardDeliveryReportFiltersInput
  ) => Promise<void>;
  loading: boolean;
};
const useUpdateStandardDeliveryReport = (): UseUpdateStandardDeliveryReport => {
  const [updateStandardDeliveryReport, { loading }] = useMutation<
    UpdateStandardDeliveryReportMutation,
    UpdateStandardDeliveryReportMutationVariables
  >(UPDATE_STANDARD_DELIVERY_REPORT);

  const handleUpdateStandardDeliveryReport = useCallback(
    async (id: string, report: UpdateReportInput, filters: StandardDeliveryReportFiltersInput) => {
      await updateStandardDeliveryReport({
        variables: { report, filters, id },
        onError: handleGql403,
        update: (cache, data) => {
          if (!data.data?.updateStandardDeliveryReport) return;
          onUpdateReport({
            cache,
            organizationId: filters.organizationId,
            report: {
              ...data.data.updateStandardDeliveryReport,
              __typename: 'Report',
            },
          });
        },
      });
    },
    [updateStandardDeliveryReport]
  );

  return {
    handleUpdateStandardDeliveryReport,
    loading,
  };
};

export default useUpdateStandardDeliveryReport;
